var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0